"use strict";

/** Получить домен окружения */
var getEnvironDomain = function () {
  if ("undefined" != typeof window) return window.atiEnv ? window.atiEnv.baseDomain : window.location && window.location.hostname.split(".").slice(-2).join(".");
};
exports.getEnvironDomain = getEnvironDomain;